import { createSlice } from '@reduxjs/toolkit'

export const shopSlice = createSlice( {
  name:         'shop',
  initialState: {
    products:                [],
    categories:              [],
    deliveryOptions:         [],
    sizeGuides:              [],
    variants:                [],
    variantsVariations:      [],
    pagination:              {},
    settingsProductsRefetch: false,
    shopProductsRefetch:     false,
    deliveryOptionsRefetch:  false,
    sizeGuidesRefetch:       false
  },
  reducers:     {
    setShopCategories:              ( state, action ) => {
      state.categories = action.payload
    },
    setShopDeliveryOptions:         ( state, action ) => {
      state.deliveryOptions = action.payload
    },
    setShopSizeGuides:              ( state, action ) => {
      state.sizeGuides = action.payload
    },
    setShopSettingsProductsRefetch: ( state, action ) => {
      state.settingsProductsRefetch = action.payload
    },
    setShopProductsRefetch:         ( state, action ) => {
      state.shopProductsRefetch = action.payload
    },
    setDeliveryOptionsRefetch:      ( state, action ) => {
      state.deliveryOptionsRefetch = action.payload
    },
    setSizeGuidesRefetch:           ( state, action ) => {
      state.sizeGuidesRefetch = action.payload
    },
    setShopProductsList:            ( state, action ) => {
      state.products   = action.payload.data
      state.pagination = action.payload.links
    },
    setShopVariants:                ( state, action ) => {
      state.variants = action.payload
    },
    setShopVariantsVariations:      ( state, action ) => {
      state.variantsVariations = action.payload
    }
  }
} )

export const {
               setShopCategories,
               setShopDeliveryOptions,
               setShopSettingsProductsRefetch,
               setShopProductsRefetch,
               setShopProductsList,
               setDeliveryOptionsRefetch,
               setShopSizeGuides,
               setSizeGuidesRefetch,
               setShopVariants,
               setShopVariantsVariations
             } = shopSlice.actions

export default shopSlice.reducer
